import { VideosSection } from "@/components/rdo/VideosSection";

interface LegacyVideosSectionProps {
  value: any;
  onChange: (v: any) => void;
  mode: "edit" | "view";
}

export function LegacyVideosSection({ value, onChange, mode }: LegacyVideosSectionProps) {
  // Manter o comportamento atual do RDO.tsx
  // O VideosSection existente já lida com o formato legado
  return <VideosSection videos={value || []} />;
}